const CONTRACT_STATUSES = {
  PENDING_CREATION: 0,
  NA: 5
};

export default CONTRACT_STATUSES;
